<template>
  <div class="device-management-pop pop">
    <div class="pop-box">
      <div class="pop-header">
        <div class="pop-header-top clearfix">
          <div class="pop-header-left">
            <i class="icon-device"></i>
            <span class="device-name" v-if="!showEditDeviceName">{{deviceMsg.deviceName}}</span>
            <div class="input-edit-wrap" v-if="showEditDeviceName">
              <input class="input-edit-name" type="text" v-model="inputEditNameVal" v-on:keyup="onChange" :placeholder="deviceMsg.deviceName.substring(deviceMsg.deviceType.length)">
              <div class="device-type">{{deviceMsg.deviceType}}</div>
            </div>
            <i class="icon-edit" @click="editDeviceName" v-if="!showEditDeviceName"></i>
            <button class="btn-black" v-if="showEditDeviceName" @click="editDeviceNameFn" :disabled="editDeviceNameDisabled">{{$t('operation.confirm')}}</button>
          </div>
          <div class="pop-header-right">
            <button class="btn-black" :disabled="unbindDeviceDisabled" @click="ifUnbindDevice">{{$t('device.unbindDevice')}}</button>
          </div>
        </div>
        <div class="pop-header-bottom">
          <div class="pop-header-left">
            <div class="input-wrap">
              <div class="search-content" v-if="inputdefaultPlacehoder">
                <i class="icon-search"></i>
                <span class="text">{{$t('device.searchAccount')}}</span>
              </div>
              <input type="text" v-model="inputVal" v-on:keydown="hideserchContent" v-on:keyup.enter="searchMember" :disabled="inputDisabled">
            </div>
            <button class="btn-black" @click="searchMember" :disabled="searchDisabled">{{$t('device.searchMember')}}</button>
          </div>
          <div class="pop-header-right">
            <i class="icon-transfer-administrator" @click="ifTransferManager" :disabled="transferDisabled" :title="transferManagerText"></i>
            <i class="icon-delete-member" @click="ifDeleteUser" :disabled="deleteDisabled" :title="deleteUserText"></i>
          </div>
        </div>
      </div>
      <div class="pop-middle">
        <div class="member-list-wrapper" v-if="showMemberList">
          <div class="member-list clearfix">
            <div class="member-li" :class="{'member-li-right': ((userIndex + 1) % 7) === 0, 'active': showCheckbox, 'selected': user.selected}" v-for="(user, userIndex) in users" :key="userIndex" :title="user.name">
              <div class="header-img-wrap">
                <img class="header-img" v-if="user.photo === null || user.photo === ''" src="../../assets/images/default_header_img.png" alt="">
                <img class="header-img" v-if="user.photo !== null && user.photo !== ''" :src="user.photo" alt="">
              </div>
              <div class="checkbox" @click="editMember(userIndex)"></div>
              <div class="member-name">{{user.name}}</div>
            </div>
            <div class="member-li-line" v-if="isUserSelected"></div>
          </div>
          <div class="no-member" v-if="users.length === 0">
            <img src="../../assets/images/person.png" alt="">
            <div>{{$t('device.noMember')}}</div>
          </div>
          <div class="middle-btn-wrap" v-if="isUserSelected">
            <button class="btn-black" v-if="transferManagerText === $t('device.cancelTransfer')" @click="goAskTransferOperation">{{$t('device.conformTransfer')}}</button>
            <button class="btn-black" v-if="deleteUserText === $t('device.cancelDelete')" @click="goAskDeleteOperation">{{$t('device.confirmDelete')}}</button>
            <button class="btn-grey" @click="cancelFn">{{$t('list.cancel')}}</button>
          </div>
        </div>
        <div class="middle-content" v-if="!showMemberList">
          <div class="no-this-user" v-if="isUser">{{$t('device.noAccount')}}</div>
          <div class="add-user clearfix" v-if="addUser">
            <div class="add-user-left">
              <img class="add-header-img" v-if="user.photo === null" src="../../assets/images/default_header_img.png" alt="">
              <img class="add-header-img" v-if="user.photo !== null" :src="user.photo" alt="">
              <div class="add-msg">
                <div class="add-name">{{user.name}}</div>
                <div class="add-account">{{user.mobile}}</div>
              </div>
            </div>
            <div class="add-user-right" v-if="!isAddedUser" @click="addNewMember">
              <i class="icon-add-member"></i>
              <div class="add-text">{{$t('device.addMember')}}</div>
            </div>
            <div class="add-user-right" v-if="isAddedUser">{{addedUserText}}</div>
          </div>
          <div class="ask-transfer-operation" v-if="askTransferOperation">{{$t('device.ifTransferadministrator') + TransferManagerName}}?</div>
          <div class="ask-delete-operation" v-if="askDeleteOperation">
            <div v-if="userIds.length === 1">{{$t('device.ifDeleteMember') + deleteUserName}}？</div>
            <div v-if="userIds.length > 1">{{$t('device.ifDeleteMember') + deleteUserName + $t('device.and') + userIds.length + $t('device.others')}}？</div>
          </div>
          <div class="ask-unbind-operation" v-if="askUnbindOperation">{{$t('device.unbindDeviceTips')}}</div>
          <div class="middle-btn-wrap" v-if="askTransferOperation">
            <button class="btn-black" @click="confirmTransfer">{{$t('operation.confirm')}}</button>
            <button class="btn-grey" @click="cancelTransfer">{{$t('list.cancel')}}</button>
          </div>
          <div class="middle-btn-wrap" v-if="askDeleteOperation">
            <button class="btn-black" @click="confirmDelete">{{$t('operation.confirm')}}</button>
            <button class="btn-grey" @click="cancelDelete">{{$t('list.cancel')}}</button>
          </div>
          <div class="middle-btn-wrap" v-if="askUnbindOperation">
            <button class="btn-black" @click="confirmUnbind">{{$t('device.unbind')}}</button>
            <button class="btn-grey" @click="cancelUnbind">{{$t('list.cancel')}}</button>
          </div>
          <div class="middle-btn-wrap" v-if="isUser || addUser">
            <button class="btn-grey" @click="cancelSearch">{{$t('list.cancel')}}</button>
          </div>
        </div>
      </div>
      <div class="pop-bottom">
        <div class="pop-bottom-top">
          <div class="pop-bottom-checkbox" :class="{'opened': deviceMsg.deviceIsPublic}" @click="isOpenDevice">
            <div class="ball"></div>
          </div>
          <span>{{$t('device.shareDevice')}}</span>
        </div>
        <div class="pop-bottom-bottom">{{$t('device.shareDeviceTips')}}</div>
      </div>
      <i class="icon-close" @click="closeDeviceManagementPop"></i>
    </div>
  </div>
</template>

<script>
import HttpClient from 'common/script/http'
import * as Config from 'common/script/config'
import User from 'common/model/User'
export default {
  name: 'deviceManagementPop',
  props: ['deviceMsg'],
  data () {
    return {
      inputVal: '',
      users: [],
      showMemberList: true,
      isUser: false,
      addUser: false,
      user: {},
      isAddedUser: false,
      showCheckbox: false,
      isUserSelected: false,
      transferManagerText: this.$t('device.transferAdministrator'),
      deleteUserText: this.$t('device.deleteMember'),
      userIds: [],
      askTransferOperation: false,
      askDeleteOperation: false,
      TransferManagerName: '',
      deleteUserName: '',
      unbindDeviceDisabled: false,
      inputDisabled: false,
      searchDisabled: false,
      transferDisabled: false,
      deleteDisabled: false,
      askUnbindOperation: false,
      deviceModel: '',
      showEditDeviceName: false,
      inputEditNameVal: '',
      editDeviceNameDisabled: false,
      inputdefaultPlacehoder: true,
      manager: [],
      addedUserText: ''
    }
  },
  created () {
    this.getMemberList()
  },
  watch: {
    inputVal: function (val) {
      if (val === '') {
        this.searchDisabled = true
      } else {
        this.searchDisabled = false
      }
    },
    showMemberList: function (val) {
      if (!val) {
        this.unbindDeviceDisabled = true
        this.inputDisabled = true
        this.searchDisabled = true
        this.transferDisabled = true
        this.deleteDisabled = true
      } else {
        this.unbindDeviceDisabled = false
        this.inputDisabled = false
        this.searchDisabled = false
        this.transferDisabled = false
        this.deleteDisabled = false
      }
    },
    inputEditNameVal: function (val) {
      if (val === '') {
        this.editDeviceNameDisabled = true
      } else {
        this.editDeviceNameDisabled = false
      }
      this.inputEditNameVal = Config.removeEmoji(this.inputEditNameVal)
    }
  },
  methods: {
    hideserchContent: function () {
      this.inputdefaultPlacehoder = false
    },
    onChange: function () {
      this.inputEditNameVal = this.inputEditNameVal.substring(0, 20)
    },
    editDeviceNameFn: function () {
      if (this.inputEditNameVal !== '') {
        const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
        HttpClient.postData(Config.APP_HOST + '/v1/device/set/alias/' + this.deviceMsg.deviceId, {u_id: uId, alias: this.deviceMsg.deviceType + this.inputEditNameVal}, this).then((response) => {
          if (response.code === Config.R_CODE.SUCCESS) {
            this.deviceMsg.deviceName = this.deviceMsg.deviceType + this.inputEditNameVal
            this.showEditDeviceName = false
          }
        })
      }
    },
    editDeviceName: function () {
      this.showEditDeviceName = true
    },
    confirmUnbind: function () {
      const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
      HttpClient.getData(Config.APP_HOST + '/v1/device/unbind/' + this.deviceMsg.deviceId + '?u_id=' + uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.closeDeviceManagementPop()
        }
      })
    },
    cancelUnbind: function () {
      this.askUnbindOperation = false
      this.showMemberList = true
    },
    ifUnbindDevice: function () {
      this.showMemberList = false
      this.askUnbindOperation = true
    },
    cancelTransfer: function () {
      this.cancelFn()
      this.showMemberList = true
      this.askTransferOperation = false
    },
    confirmTransfer: function () {
      const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
      HttpClient.getData(Config.APP_HOST + '/v1/device/transfer/user/' + this.deviceMsg.deviceId + '/' + this.userIds[0] + '?u_id=' + uId, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          this.closeDeviceManagementPop()
          // 刷新设备列表
        }
      })
    },
    goAskTransferOperation: function () {
      this.userIds = []
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].selected === true) {
          this.userIds.push(this.users[i].userId)
          this.TransferManagerName = this.users[i].name
        }
      }
      this.showMemberList = false
      this.askTransferOperation = true
    },
    confirmDelete: function () {
      const userIdsStr = this.userIds.join(',')
      const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
      HttpClient.getData(Config.APP_HOST + '/v1/device/delete/users/' + this.deviceMsg.deviceId + '?userIdsStr=' + userIdsStr + '&u_id=' + uId, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          this.deleteUserText = this.$t('device.deleteMember')
          this.showCheckbox = false
          this.isUserSelected = false
          this.getMemberList()
          this.showMemberList = true
          this.askDeleteOperation = false
        }
      })
    },
    cancelDelete: function () {
      this.cancelFn()
      this.showMemberList = true
      this.askDeleteOperation = false
    },
    goAskDeleteOperation: function () {
      this.userIds = []
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].selected === true) {
          this.userIds.push(this.users[i].userId)
          this.deleteUserName = this.users[i].name
        }
      }
      this.showMemberList = false
      this.askDeleteOperation = true
    },
    ifTransferManager: function () {
      this.cancelOperation()
      this.changeTransferManagerText(this.transferManagerText)
    },
    ifDeleteUser: function () {
      this.cancelOperation()
      this.changeDeleteText(this.deleteUserText)
    },
    cancelFn: function () {
      this.showCheckbox = false
      this.cancelOperation()
      this.transferManagerText = this.$t('device.transferAdministrator')
      this.deleteUserText = this.$t('device.deleteMember')
    },
    cancelOperation: function () {
      for (var i = 0; i < this.users.length; i++) {
        this.users[i].selected = false
      }
      this.isUserSelected = false
    },
    changeDeleteText: function (val) {
      if (val === this.$t('device.deleteMember') || val === true) {
        this.transferManagerText = this.$t('device.transferAdministrator')
        this.deleteUserText = this.$t('device.cancelDelete')
        this.showCheckbox = true
      } else {
        this.deleteUserText = this.$t('device.deleteMember')
        this.showCheckbox = false
      }
    },
    changeTransferManagerText: function (val) {
      if (val === this.$t('device.transferAdministrator')) {
        this.deleteUserText = this.$t('device.deleteMember')
        this.transferManagerText = this.$t('device.cancelTransfer')
        this.showCheckbox = true
      } else {
        this.transferManagerText = this.$t('device.transferAdministrator')
        this.showCheckbox = false
      }
    },
    addNewMember: function () {
      const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
      HttpClient.getData(Config.APP_HOST + '/v1/device/add/user/' + this.deviceMsg.deviceId + '/' + this.user.id + '?u_id=' + uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.inputdefaultPlacehoder = true
          this.addUser = false
          this.inputVal = ''
          this.showCheckbox = false
          this.getMemberList()
          this.showMemberList = true
        }
      })
    },
    cancelSearch: function () {
      this.inputdefaultPlacehoder = true
      this.addUser = false
      this.isUser = false
      this.inputVal = ''
      this.showMemberList = true
    },
    searchMember: function () {
      if (this.inputVal === '') {
        this.searchDisabled = true
        this.inputdefaultPlacehoder = true
      } else {
        this.searchDisabled = false
        this.showMemberList = false
        HttpClient.postData(Config.PASSPORT_HOST + '/api/v1/public/search/user', {keyword: this.inputVal}, this).then((response) => {
          // console.log(response)
          this.isAddedUser = false
          this.addedUserText = ''
          if (response.code === Config.R_CODE.SUCCESS) {
            var user = new User()
            user.loadJson(response.body)
            this.user = user
            this.isAddedUser = false
            if (this.deviceMsg.bindUserId === this.user.id) {
              this.isAddedUser = true
              this.addedUserText = this.$t('device.administrator')
            }
            for (var i = 0; i < this.users.length; i++) {
              // console.log(this.users[i])
              // console.log(user)
              if (Number(this.users[i].userId) === user.id) {
                this.isAddedUser = true
                this.addedUserText = this.$t('device.added')
                break
              }
            }
            this.addUser = true
          } else {
            this.addUser = false
          }
          if (response.code === Config.R_CODE.USER_NO_EXIST) {
            this.isUser = true
          } else {
            this.isUser = false
          }
        })
      }
    },
    editMember: function (index) {
      if (this.transferManagerText === this.$t('device.cancelTransfer')) {
        for (var k = 0; k < this.users.length; k++) {
          if (k !== index) {
            this.users[k].selected = false
          }
        }
      }
      this.users[index].selected = !this.users[index].selected
      for (var i = 0; i < this.users.length; i++) {
        if (this.users[i].selected === true) {
          this.isUserSelected = true
          break
        } else {
          this.isUserSelected = false
        }
      }
    },
    getMemberList: function () {
      const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
      HttpClient.getData(Config.APP_HOST + '/v1/device/user/list/' + this.deviceMsg.deviceId + '?u_id=' + uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.users = []
          for (var i = 0; i < response.body.length; i++) {
            var user = new User()
            user.loadJson(response.body[i])
            if (this.deviceMsg.bindUserId !== Number(user.userId)) {
              this.users.push(user)
            } else {
              this.manager.push(user)
            }
          }
        }
      })
    },
    isOpenDevice: function () {
      this.deviceMsg.deviceIsPublic = !this.deviceMsg.deviceIsPublic
      // console.log(this.deviceMsg.deviceIsPublic)
      var switchPublic = 0
      if (this.deviceMsg.deviceIsPublic) {
        switchPublic = 1
      } else {
        switchPublic = 0
      }
      const uId = Config.cookieGet(Config.COOKIE_KEY.U_ID)
      HttpClient.postData(Config.APP_HOST + '/v1/device/ispublic', {u_id: uId, deviceId: this.deviceMsg.deviceId, switchPublic: switchPublic}, this).then((response) => {
        // console.log(response)
        // if (response.code === Config.R_CODE.SUCCESS) {
        //   this.choseDeviceManagementPop()
        // }
      })
    },
    closeDeviceManagementPop: function () {
      this.$emit('closeDeviceManagementPop')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.device-management-pop
  button
    min-width 80px
    height 30px
    line-height 30px
    vertical-align middle
i
  cursor pointer
.middle-btn-wrap
  width 100%
  position absolute
  left 0
  bottom 20px
.device-management-pop
  &.pop
    .pop-box
      width 640px
      height 550px
.pop-header
  width 100%
  height 110px
  padding 0 50px 0 25px
  box-sizing border-box
  .pop-header-left
    float left
  .pop-header-right
    float right
  .pop-header-top
    width 100%
    height 60px
    line-height 60px
    border-bottom 1px solid #e5e5e5
    .icon-device
      font-size 18px
      vertical-align middle
    .device-name
      font-size 24px
      margin 0 6px 0 2px
      vertical-align middle
    .input-edit-wrap
      display inline-block
      width 250px
      height 30px
      position relative
      font-size 12px
      color #999
      margin 0 6px 0 2px
      vertical-align middle
      .input-edit-name
        display block
        width 100%
        height 100%
        background-color #f5f5f5
        border-radius 4px
        padding 8px 10px 8px 40px
        box-sizing border-box
        outline none
        color #999
        &::-webkit-input-placeholder
          color #999
        &::-ms-clear
          display none
      .device-type
        position absolute
        top 0
        left 10px
        line-height 30px
    .icon-edit
      font-size 12px
      color #999
  .pop-header-bottom
    width 100%
    height 50px
    padding-top 19px
    box-sizing border-box
    .input-wrap
      display inline-block
      width 250px
      height 30px
      position relative
      font-size 12px
      color #999
      border-radius 4px
      vertical-align bottom
      input
        width 100%
        height 100%
        padding 8px 10px
        box-sizing border-box
        border-radius 4px
        outline none
        background-color #e5e5e54a
        position absolute
        top 0
        left 0
        &::-ms-clear
          display none
      .search-content
        position absolute
        top 9px
        left 11px
        .icon-search
          font-size 14px
          vertical-align text-top
    .pop-header-right
      i
        font-size 30px
        &.icon-transfer-administrator
          margin-right 30px
.pop-middle
  width 100%
  height 370px
  padding 0 25px
  box-sizing border-box
  .member-list-wrapper
    width 100%
    height 100%
    display flex
    justify-content center
    position relative
    .member-list
      width 100%
      min-height 100%
      height auto
      overflow-y auto
      /*padding-bottom 70px
      box-sizing border-box*/
      .member-li
        float left
        width 50px
        height 70px
        position relative
        margin 40px 34px 0 0
        &.member-li-right
          margin-right 0
        &.active
          .checkbox
            display block
        &.selected
          .header-img-wrap
            border 2px solid #3d3d3d
          .checkbox
            display block
            background-image url('../../assets/images/checkbox_click.png')
        .header-img-wrap
          width 50px
          height 50px
          border-radius 50%
          border 2px solid transparent
          box-sizing border-box
          margin-bottom 10px
          overflow hidden
          .header-img
            width 100%
            height 100%
        .checkbox
          top 34px
          right -16px
        .member-name
          font-size 12px
          height 13px
          color #999
          display block
          max-width 50px
          white-space nowrap
          text-overflow ellipsis
          overflow hidden
      .member-li-line
        float left
        width 100%
        height 60px
    .no-member
      display flex
      width 100%
      height 100%
      position absolute
      top 0
      left 0
      justify-content center
      align-items center
      flex-direction column
      font-size 14px
      color #999
      img
        margin-bottom 18px
  .middle-content
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    position relative
    .add-user
      width 300px
      height 50px
      .add-user-left
        float left
        height 100%
        .add-header-img
          width 50px
          height 50px
          border-radius 50%
        .add-msg
          display inline-block
          height 100%
          vertical-align top
          margin-left 8px
          text-align left
          .add-name
            font-size 16px
            margin 9px 0 7px 0
            display block
            max-width 140px
            height 16px
            line-height 16px
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
          .add-account
            font-size 14px
            color #999
            display block
            max-width 140px
            height 14px
            line-height 14px
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
      .add-user-right
        float right
        width 54px
        height 50px
        line-height 50px
        position relative
        &:hover
          .icon-add-member
            color #3d3d3d
            margin-top 3px
          .add-text
            display block
        .icon-add-member
          display block
          font-size 30px
          color #999
          margin-top 10px
          transition all .3s ease
        .add-text
          width 100%
          position absolute
          bottom 1px
          font-size 12px
          line-height 12px
          cursor pointer
          display none
    .ask-unbind-operation
      padding 0 98px
      box-sizing border-box
      font-size 14px
      line-height 24px
.pop-bottom
  width 100%
  height 70px
  padding 0 25px 0 25px
  box-sizing border-box
  border-top 1px solid #e5e5e5
  text-align left
  .pop-bottom-top
    font-size 14px
    margin 11px 0 8px
    .pop-bottom-checkbox
      display inline-block
      width 34px
      height 16px
      position relative
      background-color #fff
      border 1px solid #999
      border-radius 9px
      vertical-align sub
      cursor pointer
      &.opened
        background-color #3d3d3d
        .ball
          left 20px
      .ball
        width 12px
        height 12px
        border-radius 50%
        position absolute
        left 2px
        top 1px
        background-color #fff
        border 1px solid #999
        transition all .3s ease
  .pop-bottom-bottom
    font-size 12px
    line-height 13px
</style>



// WEBPACK FOOTER //
// src/components/Et/DeviceManagementPop.vue